import { createFileRoute } from "@tanstack/react-router";
import { InteractiveDesignSystem } from "@/pages/design-system/InteractiveDesignSystem";

export const Route = createFileRoute("/demo/design-system/interactive/")({
  component: InteractiveDesignSystem,
});
